import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Utility wrapper to create named Zustand stores with devtools enabled.
 * Falls back gracefully when the Redux DevTools extension is not present.
 *
 * @param {string} name - DevTools store name
 * @param {(set: import('zustand').StateCreator, get: () => any) => object} initializer - Store initializer
 * @returns {(selector: Function, equalityFn?: Function) => any} Zustand hook
 */
export function createStore(name, initializer) {
  return create(
    devtools(
      (...args) => initializer(...args),
      { name }
    )
  );
}


